import { useRef, useState, useCallback, useEffect } from 'react';

export const useVerticalScroll = (deps: any[] = []) => {
  const ref = useRef<HTMLDivElement | null>(null);
  const [canScroll, setCanScroll] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [scrollVisible, setScrollVisible] = useState(true);

  const handleChildScroll = useCallback((e: React.UIEvent<HTMLDivElement>) => {
    const target = e.target as HTMLDivElement;
    if (target?.scrollTop > 0) {
      setScrolled(true);
    } else {
      setScrolled(false);
    }

    if (target?.scrollTop + target?.clientHeight === target.scrollHeight) {
      setScrollVisible(false);
    } else {
      setScrollVisible(true);
    }
  }, []);

  const calculatePosition = useCallback((e: HTMLDivElement | null) => {
    if (e) {
      if (e.clientHeight < e.scrollHeight) {
        setCanScroll(true);
      } else {
        setCanScroll(false);
      }
    }
  }, []);

  const handleChildMount = useCallback(
    (e: HTMLDivElement | null) => {
      ref.current = e;
      calculatePosition(e);
    },
    [calculatePosition]
  );

  useEffect(() => {
    calculatePosition(ref.current);
    // Because we are spreading external deps, we can't check for
    // exhaustive deps
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [calculatePosition, ...deps]);

  return {
    containerProps: {
      ref: handleChildMount,
      onScroll: handleChildScroll,
    },
    topFade: scrolled,
    bottomFade: canScroll && scrollVisible,
    scrollDivRef: ref,
  };
};
